


















































































































































import { Logo } from '../atoms'
import { Vue, Component } from 'vue-property-decorator'
import { userInfo, requestDeleteAccount } from '../../store/api/user'
import { UserInfoResponse, RequestDeleteAccount, Response } from '../../store/api/type'

@Component({
  components: {
    Logo
  }
})
export default class Delete extends Vue {
  agent = ''
  email = ''
  reasonError = ''
  submitError = ''
  loading = false
  hasAccount = false
  submited = false
  reason = ''
  extra = ''
  displayPortSection = false
  displayNotifiactionSection = false
  displayForm = false
  finnoEndpoint = process.env.VUE_APP_FINNO_ENDPOINT || 'https://www.finnomena.com'
  baseURL = process.env.VUE_APP_BASE_URL || 'https://auth.finnomena.com'

  reasonOption = [
    { value: 'ไม่ต้องการระบุเหตุผล', display: 'ไม่ต้องการระบุเหตุผล' },
    { value: 'ไม่ต้องการใช้บริการ', display: 'ไม่ต้องการใช้บริการ' },
    { value: 'ไม่พอใจกับบริการ', display: 'ไม่พอใจกับบริการ' },
    { value: 'เป็นกังวลเรื่องความปลอดภัยของระบบ', display: 'เป็นกังวลเรื่องความปลอดภัยของระบบ' },
    { value: 'เป็นกังวลเรื่องข้อมูลส่วนบุคคล', display: 'เป็นกังวลเรื่องข้อมูลส่วนบุคคล' },
    { value: 'ใช้บริการลงทุนที่อื่น', display: 'ใช้บริการลงทุนที่อื่น' },
    { value: 'มีบัญชีอื่นกับทาง Finnomena', display: 'มีบัญชีอื่นกับทาง Finnomena' },
    { value: 'อื่นๆ (โปรดระบุ)', display: 'อื่นๆ (โปรดระบุ)' }
  ]

  benefits = [
    {
      detail: 'การเข้าชมบทความ ข่าวสาร วิดิโอ บทวิเคราะห์ พิเศษสำหรับสมาชิกเท่านั้น',
      src: '/img/delete/news.svg',
      alt: 'article news video live'
    },
    {
      detail: 'การเข้าร่วมงานสัมมนาออนไลน์และสถานที่จริง ที่จัดโดย Finnomena และพาร์ทเนอร์ของเรา',
      src: '/img/delete/seminar.svg',
      alt: 'seminar'
    },
    {
      detail: 'การเข้าใช้เครื่องมือช่วยเหลือในการลงทุน เช่น ข้อมูลหุ้น ข้อมูลกองทุน ระบบแนะนำกองทุน',
      src: '/img/delete/fund.svg',
      alt: 'fund'
    },
    {
      detail: 'แนะนำการลงทุนที่น่าสนใจแบบทันเหตุการณ์ตลาด',
      src: '/img/delete/tactical.svg',
      alt: 'tactical'
    },
    {
      detail: 'โอกาสรับที่ปรึกษาการลงทุนส่วนบุคคล ผู้แนะนำการลงทุนที่เหมาะสมกับลูกค้า',
      src: '/img/delete/advisor.svg',
      alt: 'advisor'
    }
  ]

  async created() {
    try {
      const resp = (await userInfo()) as UserInfoResponse
      const data = resp.data
      if (data) {
        this.email = data.email
        if (data.account) {
          this.hasAccount = true
          this.agent = data.account.agent
        }
      }
    } catch (err) {
      console.error(err)

      const resp = err as Response
      if (resp.code == 401) {
        this.backToLogin()
      } else {
        const errorMessage = encodeURIComponent(`${resp.error_message || 'ไม่สามารถเรียกดูข้อมูลได้'}`)
        this.$router.push({ path: '/internal-error', query: { error: errorMessage } })
      }
    }
  }

  async nextToBenefit() {
    if (this.hasAccount) {
      this.displayPortSection = true
    } else {
      this.displayNotifiactionSection = true
    }

    await this.$nextTick()
    let el: HTMLElement | null
    if (this.hasAccount) {
      el = this.$refs.portSection as HTMLElement
    } else {
      el = this.$refs.notificationSection as HTMLElement
    }

    if (el) {
      el.scrollIntoView({ behavior: 'smooth' })
    }
  }

  async nextToPort() {
    this.displayNotifiactionSection = true
    await this.$nextTick()
    const el = this.$refs.notificationSection as HTMLElement
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' })
    }
  }

  async nextToNotification() {
    this.displayForm = true
    await this.$nextTick()

    const el = this.$refs.detailSection as HTMLElement
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' })
    }
  }

  backToLogin() {
    const returnURL = `${this.baseURL}/privacy/data-deletion`
    location.href = `${this.finnoEndpoint}/fn3/api/auth/loginaction?return_url=${encodeURIComponent(
      returnURL
    )}&action=login`
  }

  onReasonChange() {
    this.validateReason()
  }

  validateReason(): boolean {
    if (this.reason) {
      this.reasonError = ''
      return true
    }

    this.reasonError = 'กรุณาเลือกเหตุผล'
    return false
  }

  async submit() {
    if (!this.validateReason()) {
      return
    }

    const request: RequestDeleteAccount = {
      reason: this.reason,
      extra: this.extra
    }

    this.loading = true

    try {
      await requestDeleteAccount(request)
      this.submited = true
    } catch (e) {
      const err = e as Response
      if (err.error_message) {
        this.submitError = err.error_message
      } else {
        this.submitError = 'เกิดข้อผิดพลาด'
      }
    } finally {
      this.loading = false
    }
  }
}
